<template>
  <div data-collapse="medium" data-animation="default" data-duration="400" class="navbar w-hidden-main w-hidden-medium w-nav">
    <div class="container-2 w-hidden-main w-hidden-medium w-container">
      <div class="menu-button w-nav-button" @click="mobileNav = !mobileNav">
        <div class="icon-3 w-icon-nav-menu"></div>
      </div>
      <a href="/" class="brand-2 w-nav-brand">
        <div class="div-block-51"><img src="../../static/images/cabinet-manager.png" width="28" class="image-3">
          <div class="text-block-14">Cabinet Manager</div>
        </div>
      </a>
      <nav role="navigation" class="nav-menu w-nav-menu" v-show="mobileNav">
        <a :href="'/#/dashboard?project='+ project.id" :class="'nav-link w-nav-link' + (currentPage === 'dashboard' ? ' current' : '')">Design Drawing</a>
        <a :href="'/#/statistics?project='+ project.id" :class="'nav-link w-nav-link' + (currentPage === 'statistics' ? ' current' : '')">Statistics</a>
        <a :href="'/#/items?project=' + project.id" :class="'nav-link w-nav-link' + (currentPage === 'items' ? ' current' : '')">Item</a>
        <a :href="'/#/settings?project=' + project.id" :class="'nav-link w-nav-link' + (currentPage === 'settings' ? ' current' : '')">Project Setting</a>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileNav',
  props: ['currentPage', 'project'],
  data () {
    return {
      mobileNav: false
    }
  }
}
</script>

<style scoped>
.current {
  color: white;
  background-color: #008382;
}
</style>



// WEBPACK FOOTER //
// src/components/MobileNav.vue